<script>
export default {
    props: ['data', 'value'],
    name: "filterMenu",
    data() {
        return {
            list: [],
            defaultShowLength: 6
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {
        data: {
            handler: function (val) { 
                if (val.length > 0) { 
                    this.list = val.map(item => {
                        return {...item, isShow: true, isShowMore: false};
                    })
                }
            },
            immediate: true
        }
    },
    methods: {
        filterTap(index, value) {
            // this.$set(this.value, index, value);
            let _value = [...this.value];
            if (_value[index] == value) { 
                _value[index] = null;
            } else {
                _value[index] = value;
            }
            this.$emit('input', _value);
            this.$emit('change', _value);
        },
    },
};
</script>

<template>
    <div class="filter_menu">
        <div class="list flex flex_column">
            <div class="item" v-for="(item, index) in list" :key="index" :class="{active: item.isShow}">
                <div class="name flex justify_between align_center" @click="item.isShow = !item.isShow">
                    <p>{{ item.name }}</p>
                    <div class="btn_arrow"></div>
                </div>
                <div class="list_wrap" v-if="item.isShow">
                    <div class="list flex flex_column">
                        <div class="item flex justify_between align_center" 
                        v-for="(_item, _index) in item.children" :key="_index" 
                        v-if="item.isShowMore || _index < defaultShowLength"
                        :class="{active: value[index] == _index}"
                        @click="filterTap(index, _index)">
                            <div class="checkbox"></div>
                            <p class="name">{{ _item.name }}</p>
                            <p class="length" v-if="_item.count != null">({{ _item.count }})</p>
                        </div>
                    </div>
                    <div class="btn_show_more flex justify_center align_center" 
                    v-if="item.children.length > defaultShowLength && !item.isShowMore"
                    @click="item.isShowMore = true">
                        <div class="icon"></div>
                        <p>显示更多</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.filter_menu{
    width: 2.3rem;
    color: #666;
    @media only screen and (max-width: 750px) {
        width: 100%;
        padding: .3rem .6rem;
        border-bottom: 1px solid #999;
    }
    >.list{
        // position: sticky;
        // top: .9rem;
        // left: 0;
        >.item{
            font-size: .16rem;
            border-top: 1px solid #666;
            @media only screen and (max-width: 750px) {
                // border-top: none;
                font-size: .32rem;
                &:first-child{
                    border-top: none;
                }
            }
            &.active{
                >.name{
                    .btn_arrow{
                        transform: translate(0, 25%) rotate(-45deg);
                    }
                }
            }
            >.name{
                font-size: .18rem;
                padding: .15rem 0;
                cursor: pointer;
                @media only screen and (max-width: 750px) {
                    font-size: .32rem;
                    padding: .3rem 0;
                }
                .btn_arrow{
                    width: .1rem;
                    height: .1rem;
                    border-top: 2px solid #666;
                    border-right: 2px solid #666;
                    transform: translate(0, -25%) rotate(135deg);
                    @media only screen and (max-width: 750px) {
                        width: .16rem;
                        height: .16rem;
                    }
                }
            }
            // &:last-child{
            //     .list_wrap{
            //         margin-bottom: 0;
            //     }
            // }
            .list_wrap{
                margin-bottom: .2rem;
            }
            .list{
                gap: .15rem;
                line-height: 1;
                @media only screen and (max-width: 750px) {
                    gap: .3rem;
                }
                .item{
                    cursor: pointer;
                    &:hover{
                        .name{
                            text-decoration: underline;
                            @media only screen and (max-width: 750px) {
                                text-decoration: none;
                            }
                        }
                    }
                    &.active{
                        color: #000;
                        font-weight: bold;
                        .checkbox{
                            border-color: #000;
                            &::after{
                                display: block;
                            }
                        }
                    }
                    .name{
                        flex: 1;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .checkbox{
                        width: .2rem;
                        height: .2rem;
                        border: 1px solid #666;
                        border-radius: .03rem;
                        margin-right: .1rem;
                        position: relative;
                        flex-shrink: 0;
                        @media only screen and (max-width: 750px) {
                            width: .32rem;
                            height: .32rem;
                        }
                        &::after{
                            content: "";
                            width: 30%;
                            height: 60%;
                            border-bottom: 1px solid #000;
                            border-right: 1px solid #000;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -75%) rotate(45deg);
                            display: none;
                        }
                    }
                }
            }
            .btn_show_more{
                margin-top: .15rem;
                font-size: .12rem;
                cursor: pointer;
                .icon{
                    width: .1rem;
                    height: .1rem;
                    position: relative;
                    margin-right: .05rem;
                    &::before,
                    &::after{
                        content: "";
                        display: block;
                        width: 100%;
                        border-bottom: 1px solid #666;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                    &::after{
                        transform: translate(-50%, -50%) rotate(90deg);
                    }
                }
                @media only screen and (max-width: 750px) {
                    font-size: .26rem;
                    .icon{
                        width: .2rem;
                        height: .2rem;
                    }
                }
            }
        }
    }
}
</style>